import { computed, ref } from 'vue';

import { useListeningPermissions } from '@/app/socialListening/composables/useListeningPermissions';
import { POSTS_VIEW } from '@/app/socialListening/constants.js';

// Singleton state - shared view ref only
let sharedView = null;
let isInitialized = false;

export function usePostDisplayFormatToggle() {
  const { commentsEnabled } = useListeningPermissions();

  // Initialize singleton state only once
  if (!isInitialized) {
    sharedView = ref(POSTS_VIEW.TILE);
    isInitialized = true;
  }

  const isListView = computed(() => sharedView.value === POSTS_VIEW.LIST);
  const isTileView = computed(() => sharedView.value === POSTS_VIEW.TILE);

  const setView = (view) => {
    sharedView.value = view;
  };

  return {
    view: sharedView,
    isListView,
    isTileView,
    commentsEnabled,
    setView,
  };
}
